module.exports = __webpack_public_path__ + "img/uklonjena4.a3f0acbf.jpg";